"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zip = void 0;
var tuple_1 = require("../../functions/tuple");
/** @internal */
var zip = function (array1, array2) {
    return array1.map(function (v, idx) { return (0, tuple_1.t)(v, array2[idx]); });
};
exports.zip = zip;
